export default __webpack_public_path__ + "locales/uk-UA/Translations.json?hash=bd54ba2f6a25df8eb8bd6c6e463cbec5";